import React from 'react';

import {
  Router as ReactRouter,
  hashHistory,
  IndexRoute,
  Route,
} from 'react-router';

import store from './store';
import {
  isNotAuthenticated,
  isAuthenticated,
  shouldViewLoader,
} from './lib/router';

import SignUp, {
  SignUpWelcome,
  SignUpUserType,
  SignUpEmployee,
  SignUpAccount,
  SignUpConfirmation,
  SignUpCarousel,
} from './components/sign_up';
import App from './components/app';
import Loader from './components/Loader';
import { Timeclock } from './components/timeclock/main';
import { Setup } from './components/setup/main';

export default function Router() {
  return (
    <ReactRouter history={hashHistory}>
      <Route component={App}>
        {/* displays while the state is being hydrated */}
        <IndexRoute component={Loader} onEnter={shouldViewLoader(store)} />
        <Route
          path="timeclock"
          onEnter={isAuthenticated(store)}
          component={Timeclock}
        />
        <Route
          path="setup"
          component={Setup}
        />
      </Route>

      {/* Sign up flow */}
      <Route component={SignUp} onEnter={isNotAuthenticated(store)}>
        <Route path='welcome' component={SignUpWelcome} />
        <Route path='user' component={SignUpUserType} />
        <Route path='employee' component={SignUpEmployee} />
        <Route path='account' component={SignUpAccount} />
        <Route path='done' component={SignUpConfirmation} />
        <Route path='info' component={SignUpCarousel} />
      </Route>
    </ReactRouter>
  );
}



// WEBPACK FOOTER //
// ./src/router.jsx